<template>
  <div class="center">
    <slot/>
  </div>
</template>

<script>
export default {
name: 'loginLayout',


}
</script>

<style scoped> 
.center{
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  display: flex;
  background-color: #f0f0f0;
}
</style>